import { render } from "./ContactsPage2.vue?vue&type=template&id=acb1a1e4"
import script from "./ContactsPage2.vue?vue&type=script&lang=js"
export * from "./ContactsPage2.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__